import React, { useState, useContext, useEffect } from "react";
import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import { LangCtx, RoleCtx, FileCtx, SignalerCtx } from "../../../lib/context";
import { useLocation } from "react-router-dom";

import AppointmentsList from "./components/appointmentsList";
import UploadFileView from "../fileUploads/components/uploadFileView";
import FeedBackPopup from "../../conference/FeedBackPopup";

const Appointments = (props) => {
    const location = useLocation();
    const { signaler } = useContext(SignalerCtx);
    const [active, setActive] = useState(location.state?.active ?? "UA");
    const { l } = useContext(LangCtx);
    const { role } = useContext(RoleCtx);
    const [selFile, setFileView] = useState(null);
       const [openFeedback, setOpenFeedback] = useState(false);
            const handleOpenFeedback = () => {
                setOpenFeedback(true);
              };
            
              const handleCloseFeedback = () => {
                setOpenFeedback(false);
              };


    useEffect(() => {
        const doctorUserId = localStorage.getItem("meetingUserId");
        const meetingObj = JSON.parse(localStorage.getItem("meetingObj"));
        let doctorObj = {...meetingObj?.doctorData};
        doctorObj["apptId"] = meetingObj?.appointmentId;
        if (
            doctorUserId &&
            doctorUserId !== "" &&
            doctorObj &&
            doctorObj !== ""
        ) {
            signaler.exitWaitingRoom(meetingObj.appointmentId, doctorUserId);
            signaler.declineCallRequest(doctorUserId, doctorObj);
            localStorage.removeItem('meetingUserId');
            localStorage.removeItem('meetingObj');
        }
    }, [signaler]);


    return (
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt"  onClick={handleOpenFeedback}>{l.apptmnts}</h2>


                </div>
                <div className="tabCol">
                    <div className="row hndlpdn08">
                        <div
                            className={active === "UA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                            onClick={(e) => setActive("UA")}
                        >
                            <span>{l.upcoming}</span>
                        </div>
                        <div
                            className={active === "PA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                            onClick={(e) => setActive("PA")}
                        >
                            <span>{l.past}</span>
                        </div>
                        <div
                            className={active === "CA" ? "tabInline tabFlx1 active" : "tabInline tabFlx1"}
                            onClick={(e) => setActive("CA")}
                        >
                            <span>{l.cancelled_or_rejected}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ptntLstCntnr">
                <FileCtx.Provider value={{ selFile, setFileView }}>
                    <AppointmentsList type={active} role={role} />
                </FileCtx.Provider>
                {selFile !== null && <UploadFileView open={selFile !== null} handleClose={() => setFileView(null)} data={selFile} />}
            </div>
            {openFeedback && <FeedBackPopup open={openFeedback} onClose={handleCloseFeedback}/>}
        </div>
    );
};

export default Appointments;
